var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccessFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 6.25c9.803 0 17.75 7.947 17.75 17.75S33.803 41.75 24 41.75 6.25 33.803 6.25 24 14.197 6.25 24 6.25zm-2.799 23.954a.8.8 0 001.132 0l8.568-8.568a.8.8 0 000-1.132l-1.272-1.272a.8.8 0 00-1.131 0l-6.73 6.731-3.332-3.331a.8.8 0 00-1.132 0l-1.272 1.271a.8.8 0 000 1.132l5.17 5.169z",
    id: "success-filled_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#8fc056",
    xlinkHref: "#success-filled_svg__a",
    transform: "translate(-6 -6)"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTI0IDYuMjVjOS44MDMgMCAxNy43NSA3Ljk0NyAxNy43NSAxNy43NVMzMy44MDMgNDEuNzUgMjQgNDEuNzUgNi4yNSAzMy44MDMgNi4yNSAyNCAxNC4xOTcgNi4yNSAyNCA2LjI1em0tMi43OTkgMjMuOTU0YS44LjggMCAwIDAgMS4xMzIgMGw4LjU2OC04LjU2OGEuOC44IDAgMCAwIDAtMS4xMzJsLTEuMjcyLTEuMjcyYS44LjggMCAwIDAtMS4xMzEgMGwtNi43MyA2LjczMS0zLjMzMi0zLjMzMWEuOC44IDAgMCAwLTEuMTMyIDBsLTEuMjcyIDEuMjcxYS44LjggMCAwIDAgMCAxLjEzMmw1LjE3IDUuMTY5eiIgaWQ9ImEiLz48L2RlZnM+PHVzZSBmaWxsPSIjOGZjMDU2IiB4bGluazpocmVmPSIjYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYgLTYpIi8+PC9zdmc+";
export { SvgSuccessFilled as ReactComponent };